/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AdminStockAdjustLocationAddBoxResVo } from './AdminStockAdjustLocationAddBoxResVo';
import {
    AdminStockAdjustLocationAddBoxResVoFromJSON,
    AdminStockAdjustLocationAddBoxResVoFromJSONTyped,
    AdminStockAdjustLocationAddBoxResVoToJSON,
    AdminStockAdjustLocationAddBoxResVoToJSONTyped,
} from './AdminStockAdjustLocationAddBoxResVo';

/**
 * 
 * @export
 * @interface ResponseAdminStockAdjustLocationAddBoxResVo
 */
export interface ResponseAdminStockAdjustLocationAddBoxResVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseAdminStockAdjustLocationAddBoxResVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseAdminStockAdjustLocationAddBoxResVo
     */
    message?: string;
    /**
     * 
     * @type {AdminStockAdjustLocationAddBoxResVo}
     * @memberof ResponseAdminStockAdjustLocationAddBoxResVo
     */
    data?: AdminStockAdjustLocationAddBoxResVo;
}

/**
 * Check if a given object implements the ResponseAdminStockAdjustLocationAddBoxResVo interface.
 */
export function instanceOfResponseAdminStockAdjustLocationAddBoxResVo(value: object): value is ResponseAdminStockAdjustLocationAddBoxResVo {
    return true;
}

export function ResponseAdminStockAdjustLocationAddBoxResVoFromJSON(json: any): ResponseAdminStockAdjustLocationAddBoxResVo {
    return ResponseAdminStockAdjustLocationAddBoxResVoFromJSONTyped(json, false);
}

export function ResponseAdminStockAdjustLocationAddBoxResVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseAdminStockAdjustLocationAddBoxResVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : AdminStockAdjustLocationAddBoxResVoFromJSON(json['data']),
    };
}

export function ResponseAdminStockAdjustLocationAddBoxResVoToJSON(json: any): ResponseAdminStockAdjustLocationAddBoxResVo {
    return ResponseAdminStockAdjustLocationAddBoxResVoToJSONTyped(json, false);
}

export function ResponseAdminStockAdjustLocationAddBoxResVoToJSONTyped(value?: ResponseAdminStockAdjustLocationAddBoxResVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': AdminStockAdjustLocationAddBoxResVoToJSON(value['data']),
    };
}

